const prefix = 'angleInput';
export const dataHooks = {
    knob: `${prefix}-knob`,
    knobWrapper: `${prefix}-knobWrapper`,
    track: `${prefix}-track`,
    wrapper: `${prefix}-wrapper`,
    input: `${prefix}-input`,
};
export const angleLimits = {
    min: 0,
    max: 359,
};
//# sourceMappingURL=AngleInput.constants.js.map